import styled, { css } from 'styled-components';

export const Card = styled.div<{
  $shadow?: boolean;
  $padding?: number;
}>`
  width: 100%;
  box-sizing: border-box;
  border-radius: 24px;
  padding: ${({ $padding = 20 }) => `${$padding}px`};
  background-color: #fff;
  ${({ $shadow }) =>
    $shadow &&
    css`
      box-shadow: var(--shadow-base);
    `};
`;

export default Card;